import DisabledTooltip from "@/UI/DisabledTooltip"
import { isAdminAtom, isOwnerAtom, userAtom } from "@/atoms/userAtom"
import { useOrg } from "@/hooks/useOrg"
import { DistanceUnit, DistanceUnits } from "@/types/localization.types"
import { faRoad } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Dropdown, Space } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { useRecoilValue } from "recoil"

interface DistanceUnitSwitcherProps {}

const DistanceUnitSwitcher: React.FC<DistanceUnitSwitcherProps> = () => {
  const { t } = useTranslation()
  const { preference } = useRecoilValue(userAtom)
  const { updateOrgPreferences } = useOrg()
  const selectedDistanceUnitKey = Object.values(DistanceUnits).find(
    (unit) => unit.value === preference.distanceUnit
  )?.nameKey
  const isOwner = useRecoilValue(isOwnerAtom)
  const isAdmin = useRecoilValue(isAdminAtom)
  const userCanChange = isOwner || isAdmin

  return (
    <>
      <span>{t("common.unitOfDistance")}:</span>
      <DisabledTooltip enable={!userCanChange} label={t`common.onlyAdminOrOwnerCanChange`}>
        <Dropdown
          disabled={!userCanChange}
          menu={{
            items: Object.keys(DistanceUnits).map((key) => {
              return {
                key: DistanceUnits[key]!.value,
                label: t(DistanceUnits[key]!.nameKey),
              }
            }),
            onClick: async (e) => {
              await updateOrgPreferences({
                ...preference,
                distanceUnit: e.key as DistanceUnit,
              })
            },
          }}
        >
          <Button type="text" size="large" onClick={(e) => e.preventDefault()}>
            <Space>
              {t(selectedDistanceUnitKey!)}
              <FontAwesomeIcon icon={faRoad} />
            </Space>
          </Button>
        </Dropdown>
      </DisabledTooltip>
    </>
  )
}

export default DistanceUnitSwitcher
